/** Checklist for software savings / tech discount opportunities. */
export const SOFTWARE_SAVINGS_TASKS = [
  {
    id: 1,
    name: "Identify savings opportunity",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Confirm current vendor and spend", completed: false },
      { id: "1-2", name: "Verify client is eligible for discount program", completed: false },
    ],
  },
  {
    id: 2,
    name: "Prepare and submit request",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Gather account details from client", completed: false },
      { id: "2-2", name: "Submit discount or credits application", completed: false },
      { id: "2-3", name: "Follow up with vendor if needed", completed: false },
    ],
  },
  {
    id: 3,
    name: "Confirm savings applied",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Verify discount on client invoice or account", completed: false },
      { id: "3-2", name: "Update client and close opportunity", completed: false },
    ],
  },
];
